import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { operationTypes } from '../../constants/constants.js';
import Stake from './items/Stake';
import AccHistoryInfo from './items/AccHistoryInfo';
export default function (type, operationsData) {
    // eslint-disable-next-line default-case
    switch (type) {
        case operationTypes.STAKE:
        case operationTypes.STAKE_PAYMENT:
            return _jsx(Stake, { operationsData: operationsData, type: type }, operationsData.TransactionId);
        case operationTypes.DEPOSIT:
        case operationTypes.WITHDRAWAL:
        case operationTypes.RINGOGAMES_STAKE:
        case operationTypes.RINGOGAMES_STAKE_PAYMENT:
        case operationTypes.ACCOUNT_CORRECTION:
        case operationTypes.BONUS:
        case operationTypes.COMBOBET_STAKE:
        case operationTypes.COMBOBET_STAKE_WON:
        case operationTypes.BETGAMES_STAKE:
        case operationTypes.BETGAMES_STAKE_PAYMENT:
        case operationTypes.HOLLYWOOD_TV_STAKE:
        case operationTypes.HOLLYWOOD_TV_STAKE_PAYMENT:
        case operationTypes.VIVO_STAKE:
        case operationTypes.VIVO_STAKE_PAYMENT:
        case operationTypes.VIRTUAL_SPORTS:
        case operationTypes.VIRTUAL_SPORTS_PAYMENT:
        case operationTypes.BETSOLUTIONS_STAKE:
        case operationTypes.BETSOLUTIONS_STAKE_PAYMENT:
        case operationTypes.TVBET_STAKE:
        case operationTypes.TVBET_STAKE_PAYMENT:
        case operationTypes.DATABET_STAKE:
        case operationTypes.DATABET_STAKE_PAYMENT:
        case operationTypes.XPRESS_STAKE:
        case operationTypes.XPRESS_STAKE_PAYMENT:
            return _jsx(AccHistoryInfo, { operationsData: operationsData, type: type }, operationsData.TransactionId);
    }
}



// WEBPACK FOOTER //
// ./src/components/account-history/AccHistoryComponentFactory.jsx